import { Controller } from "../controls/controller";
import { GameState } from "../state/game-state";
import { TextMenu } from "./menu";
import { MenuKeys } from "./menu-keys";

export class MenuManager {
  currentMenu: MenuKeys[] = [];
  menus: Map<MenuKeys, TextMenu>;
  constructor(menus: { name: MenuKeys; menu: TextMenu }[]) {
    this.menus = new Map();
    menus.forEach(({ name, menu }) => this.menus.set(name, menu));
  }

  isVisible(menuKey: MenuKeys): boolean {
    return this.topMenu === menuKey;
  }

  get topMenu() {
    return this.currentMenu.at(-1);
  }

  pushMenu(menuKey: MenuKeys): void {
    if (!this.menus.has(menuKey)) {
      return;
    }
    if (this.currentMenu.at(-1) === menuKey) {
      return;
    }
    const topMenu = this.topMenu;
    if (topMenu) {
      this.menus.get(this.topMenu)?.remove();
    }
    this.currentMenu.push(menuKey);
    this.menus.get(menuKey)!.show();
    console.log({ menus: this.currentMenu, current: this.topMenu });
  }

  replaceMenu(menuKey: MenuKeys): void {
    if (!this.menus.has(menuKey)) {
      return;
    }
    if (this.currentMenu.at(-1) === menuKey) {
      return;
    }
    const topMenu = this.topMenu;
    if (topMenu) {
      this.menus.get(topMenu)?.remove();
    }
    this.currentMenu.pop();
    this.currentMenu.push(menuKey);
    this.menus.get(menuKey)!.show();
    console.log({ menus: this.currentMenu, current: this.topMenu });
  }

  closeMenu(menuKey: MenuKeys): void {
    if (!this.menus.has(menuKey)) {
      return;
    }
    if (this.topMenu === menuKey) {
      this.currentMenu.pop();
    }
    this.menus.get(menuKey)?.remove();
    const previous = this.topMenu;
    console.log({ menus: this.currentMenu, current: this.topMenu });
    if (!previous) return;
    this.menus.get(previous)?.show();
  }

  up() {
    if (!this.topMenu) {
      return;
    }
    this.menus.get(this.topMenu)?.up();
  }

  down() {
    if (!this.topMenu) {
      return;
    }
    this.menus.get(this.topMenu)?.down();
  }

  activate(ctx?: {
    gameState: GameState;
    menuManager: MenuManager;
    controller: Controller;
  }) {
    if (!this.topMenu) {
      return;
    }
    this.menus.get(this.topMenu)?.activate(ctx);
    console.log("menumManager.activate", {
      menus: this.currentMenu,
      current: this.topMenu,
    });
  }
}
